import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parentcontainer',
  templateUrl: './parentcontainer.component.html',
  styleUrls: ['./parentcontainer.component.css']
})
export class parentcontainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shell/Parent-Portal/parentcontainer/parentcontainer.component.ts